import { useCallback, useState } from 'react';
import { API_BASE } from '../../../config/constants';

export function useRequests() {
    const [requests, setRequests] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);

    const loadAllRequests = useCallback(async (): Promise<any[]> => {
        setLoading(true);
        setError(null);

        console.debug('[useRequests] loadAllRequests called');
        try {
            const response = await fetch(`${API_BASE}/api/users/get-all-requests`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
            });

            const result = await response.json().catch(() => ({}));

            console.debug('[useRequests] loadAllRequests response', { ok: response.ok, length: Array.isArray(result?.data) ? result.data.length : (Array.isArray(result) ? result.length : 0) });

            if (!response.ok || !result?.success) {
                throw new Error(result?.message || 'Failed to fetch requests');
            }

            const requestRows = Array.isArray(result?.data) ? result.data : [];
            setRequests(requestRows);
            return requestRows;
        } catch (err: any) {
            console.error('useRequests: Error fetching all requests:', err);
            setError(err?.message || 'Failed to fetch requests');
            setRequests([]);
            return [];
        } finally {
            setLoading(false);
        }
    }, []);


    // Filters the current requests state by object_owner_id
    const loadRequestsByOwner = useCallback((ownerId: string | number) => {
        if (!Array.isArray(requests)) return [];
        return requests.filter((r: any) => String(r.object_owner_id) === String(ownerId));
    }, [requests]);

    
    // Filters the current requests state by requesting user id (r.user)
    const loadRequestsByUser = useCallback((userId: string | number) => {
        if (!Array.isArray(requests)) return [];
        return requests.filter((r: any) => String(r.user) === String(userId));
    }, [requests]);

    return {
        requests,
        loading,
        error,
        loadAllRequests,
        loadRequestsByOwner,
        loadRequestsByUser,
    };
}
